import React, {useContext, useEffect, useState} from 'react';
import {
    Box,
    Button,
    CircularProgress,
} from '@mui/material';
import {
    useRecordContext,
    useNotify, Show
} from 'react-admin';
import { AdminUserContext } from "../../../contexts/AdminUserContextProvider";
import { useGetIdentity } from 'react-admin';

const overlayStyles = {
    width: '100vw',
    height: '100vh',
    position: 'fixed',
    top: 0,
    left: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 99999,
};

const sectionTitleStyles = {
    paddingLeft: '16px',
    fontSize: '18px',
    fontWeight: 'bold',
    marginTop: '16px',
    display: 'block'
};

const CustomerNoteAction = (props) => {
    const context = useContext(AdminUserContext);
    const [processing, setProcessing] = useState(false);
    const record = useRecordContext();
    const notify = useNotify();
    const [note, setNote] = useState(null);
    const [canShow, setCanShow] = useState(false);
    const { data: identity, isPending: isPendingIdentity } = useGetIdentity();

    const sendCustomerNote = async () => {
        setProcessing(true);
        if (note === null || note === '' || note.length <= 1) {
            notify('Please enter a note to send to TIP.', { type: 'warning' });
            setProcessing(false);
            return;
        }
        await context.sendCustomerNote(note, record.id, identity.id)
            .then(response => {
                setProcessing(false);
                if (typeof response.data !== 'undefined' && response.data.success === true) {
                    notify(response.data.message, { type: 'success' });
                } else {
                    notify(response.error_message, { type: 'error' });
                }
            });
    };

    return (
        <Box>
            <Box sx={ { width: '100%', display: 'flex', marginLeft: '15px', justifyContent: 'flex-start', paddingBottom: '10px' } } >
                <div className="input-group" style={{ marginTop: '10px', display: 'block'}}>
                    <textarea
                        id="note"
                        style={{position: 'relative', top: '2px', minWidth: '425px', minHeight: '100px', display: 'inline-block', marginRight: '20px'}}
                        onChange={e => setNote(e.target.value)}
                        value={note}
                        placeholder={ "Enter a note about this customer to be sent to TIP."}
                    />
                    <Button
                        style={{position: 'relative', display: 'block', marginTop: '10px'}}
                        variant="contained"
                        onClick={sendCustomerNote}
                        title="Submit Note"
                        color="primary"
                    >
                        Send Note
                    </Button>
                </div>
            </Box>

            <Box sx={ { width: '100%', marginLeft: '15px', marginTop: '5px', paddingBottom: 0 } }>
                <h3 style={{marginBottom: 0}}>Previous notes:</h3>
                <Box sx={ { width: '100%', display: 'flex', flexDirection: 'column', marginTop: 0, justifyContent: 'flex-start', paddingBottom: '20px' } } >
                    { typeof record !== 'undefined' && typeof record.pharmacyNotes !== 'undefined' && record.pharmacyNotes.map((note, index) => {
                        const date = new Date(note.createdAt).toLocaleDateString('en-GB');
                        return (
                            <Box key={index} sx={{display: 'block', marginTop: '10px'}}>
                                <span style={{color: "green"}}>Note added on { date + ':'}</span>
                                <span style={{color: 'black'}}> <p>{ note.note }</p></span>
                            </Box>
                        )
                    })}
                    { typeof record !== 'undefined' && typeof record.pharmacyNotes !== 'undefined' && record.pharmacyNotes.length === 0 && (
                        <Box sx={{marginTop: 0, marginBottom: '10px'}}>
                            No customer notes have been sent to TIP yet.
                        </Box>
                    ) }
                </Box>
            </Box>

            { processing &&
                <Box sx={ overlayStyles } >
                    <Box sx={ { display: 'flex', flexDirection: 'column', background: '#fff', padding: '10px', borderRadius: '25px;', alignItems: 'center' } }>
                        <span style={ { marginBottom: '15px', fontSize: '20px' } } >{ "Sending customer note to TIP, please wait..." }</span>
                        <CircularProgress />
                    </Box>
                </Box>
            }
        </Box>
    );
}

export const TipCustomerNote = (props) => {

    return (
        <Show title="Customer Notes" actions={false}>
            <span style={sectionTitleStyles}>{"Customer Notes"}</span>
            <CustomerNoteAction />
        </Show>
    );
}